<htx-button variant="tertiary" icon="arrow_back" (click)="goBack()">
  {{ 'button.back' | transloco }}
</htx-button>

<article class="glossary-container" *transloco="let t; prefix: 'glossary'">
  <h1 class="gl-title">{{ t('title') }}</h1>

  <p class="gl-intro">
    Dieses Glossar erläutert die wichtigsten Begriffe des HealthTrack-X Datenraums. Die Spalte
    <strong>„Sitra Rulebook 3.0 Terminologie"</strong> gibt die zugrunde liegende Standard-Definition
    wieder, die Spalte <strong>„Anmerkungen"</strong> enthält ergänzende Erläuterungen zur Bedeutung
    im vertraglichen Rahmen des HT-X Regelwerks.
  </p>

  <section class="gl-entry">
    <h2 class="gl-term">Daten</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Jede digitale Darstellung von Handlungen, Tatsachen oder Informationen sowie jede
          Zusammenstellung solcher Handlungen, Tatsachen oder Informationen auch in Form von Ton-,
          Bild- oder audiovisuellem Material; vgl. Art. 2(1) Data Act („DA"), Art. 2(1) Data
          Governance Act („DGA").
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Personenbezogene Daten</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche
          Person beziehen. (Art. 4(1) DSGVO)
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Datensatz / Datenprodukt</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Ein Datensatz kann entweder ein Datensatz sein, d. h. „eine Ressource, die eine Sammlung
          von Daten umfasst, die von einer einzelnen Partei veröffentlicht oder kuratiert wurde und
          in einer oder mehreren Darstellungen zugänglich oder zum Download verfügbar ist", oder ein
          Datenprodukt, d. h. „eine Menge von Ressourcen, die einer Datenproduktspezifikation
          entspricht und für die ein Datenprodukt-Eigentümer ein Datenproduktangebot erstellt und
          veröffentlicht hat."
        </p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Im vertraglichen Rahmen des Regelwerks bezeichnet „Datensatz" eine Sammlung von Daten,
          deren Nutzung der Datenanbieter über den Datenraum autorisiert. Datensätze und die damit
          verbundenen Bedingungen werden in den jeweiligen Nutzungsbedingungen für Datensätze näher
          definiert.
        </p>
        <p>
          Laut dem DSSC-Glossar v3.0 ist ein Datensatz: „Eine Ressource, die eine Sammlung von Daten
          umfasst, die von einer einzelnen Partei veröffentlicht oder kuratiert wurde und in einer
          oder mehreren Darstellungen zugänglich oder zum Download verfügbar ist."
        </p>
        <p>
          Datenprodukt: „Ein Satz von Ressourcen, der einer Datenproduktspezifikation entspricht und
          für den ein Datenprodukteigentümer ein Datenproduktangebot erstellt und veröffentlicht
          hat."
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Gemeinsame Datennutzung</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Gemeinsame Nutzung von Daten: Zugriff auf dieselben Daten oder deren Verarbeitung durch
          mehr als eine befugte Einrichtung. Die gemeinsame Nutzung von Daten kann z. B. erfolgen,
          indem (i) der Zugriff auf den ursprünglichen Datensatz oder die Ausführung von Operationen
          mit diesem ermöglicht wird oder (ii) indem eine Kopie der Daten an die interessierte
          Einrichtung weitergegeben wird. Die Art und Weise, wie Daten gemeinsam genutzt werden, hat
          einen grundlegenden Einfluss auf die verfügbaren Kontrollen und die erforderlichen Angaben
          im Regelwerk.
        </p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>See draft ISO/IEC 20151.</p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Datenraum</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Ein verteiltes System, das durch das Regelwerk definiert wird und sichere sowie
          vertrauenswürdige Datentransaktionen zwischen Teilnehmern ermöglicht, während es Vertrauen
          und Datenhoheit unterstützt. Ein Datenraum wird durch eine oder mehrere Infrastrukturen
          umgesetzt und ermöglicht einen oder mehrere Anwendungsfälle.
        </p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Im vertraglichen Rahmen des Regelwerks bezeichnet „Datenraum" die Gruppe, bestehend aus den
          Parteien, die Daten im Einklang mit dem Gründungsvertrag gemeinsam nutzen.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Regelwerk / Rulebook</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Ein verbindlicher Satz von Dokumenten, die die Governance-Struktur des Datenraums
          aufzeichnen und somit den Datenraum definieren.
        </p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Im DSSC-Konzeptionsmodell definiert eine Datenraum-Governance-Struktur einen Datenraum.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Teilnehmer / Datenraumteilnehmer</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Eine Partei, die dem Regelwerk eines bestimmten Datenraums verpflichtet ist und eine Reihe
          von Rechten und Pflichten hat, die sich aus diesem Regelwerk ergeben.
        </p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>Nutzer des Datenraums.</p>
        <p>
          Teilnehmer ist eine juristische oder natürliche Person, die am HT-X Datenraum teilnimmt und
          den für die Teilnahme geltenden Regelungen des Rulebooks unterliegt. Teilnehmer können
          Mitglieder des Datenraumträgers sein, müssen dies jedoch nicht.
        </p>
        <p>
          Teilnehmer können Datenanbieter, Datennutzer, Diensteanbieter, Betreiber oder sonstige im
          Rulebook definierte Rollen wahrnehmen.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Mitglied</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Eine juristische oder natürliche Person, die dem Datenraumträger angehört und die Rechte
          und Pflichten eines Mitglieds gemäß Gründungsvertrag, Rulebook und Governance-Modell
          besitzt.
        </p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Mitglieder gehören dem Datenraumträger an und besitzen die Rechte und Pflichten eines
          Mitglieds gemäß Gründungsvertrag, Rulebook und Governance-Modell.
        </p>
        <p>
          Mitglieder wirken an der Governance des Datenraums mit und sind berechtigt, über die
          hierfür vorgesehenen Gremien an Entscheidungen zur Weiterentwicklung des Datenraums
          mitzuwirken.
        </p>
        <p>
          Mitglied ist ein Teilnehmer des HT-X Datenraums, der dem Datenraumträger angehört und
          zusätzliche Governance-Rechte und -Pflichten gemäß Gründungsvertrag, Rulebook und
          Governance-Modell besitzt.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Gründungsmitglied</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>Ein erster Datenraumteilnehmer, der die Gründungsvereinbarung unterzeichnet.</p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>Gründungsmitglieder bilden die ursprüngliche Trägerschaft des Datenraums.</p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Datenraum-Governance-Instanz</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Eine oder mehrere Parteien, die das Regelwerk eines Datenraums aufstellen, regeln,
          verwalten und durchsetzen. Das Governance-Modell ist ein Instrument zur Festlegung einer
          vertraglichen Vereinbarung oder einer juristischen Person zur Einrichtung der
          Datenraum-Governance-Instanz.
        </p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Die Organisationen und Gremien, die für die Governance des Datenraums verantwortlich sind.
          Im HT-X Datenraum umfasst dies insbesondere den Datenraumträger und dessen
          Governance-Gremien, insbesondere den Lenkungsausschuss.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Datenanbieter</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Ein Datenraumteilnehmer, der im Rahmen einer bestimmten Datentransaktion den Datennutzern,
          die das Recht oder die Pflicht haben, auf diese Daten zuzugreifen und/oder sie zu erhalten,
          Daten technisch zur Verfügung stellt.
        </p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Im vertraglichen Rahmen des Regelwerks bezeichnet der Begriff „Datenanbieter" jede
          natürliche Person oder Organisation, die den Parteien Daten zur Nutzung über den Datenraum
          zur Verfügung stellt.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Dienstleister</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Ein Datenraumteilnehmer, der auf der Grundlage von Daten oder Datensätzen im Datenraum
          wertschöpfende Dienste anbietet.
        </p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Im vertraglichen Rahmen des Regelwerks wird definiert, dass „Diensteanbieter" jede der
          Parteien ist, die Daten kombiniert, aufbereitet und verarbeitet und die verarbeiteten Daten
          und/oder einen auf den Daten basierenden Dienst zur Nutzung durch Datennutzer, andere
          Diensteanbieter oder Drittnutzer zur Verfügung stellt.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Datennutzer</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>Ein Datenraumteilnehmer, dem das Recht (die Rechte) zur Nutzung von Daten eingeräumt wird.</p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Ein Datennutzer kann ein „Datenempfänger" iSd Art. 2(14) DA oder ein „Datennutzer" iSd
          Art. 2 Z 6 DGA sein.
        </p>
        <p>
          Im vertraglichen Rahmen des Regelwerks bezeichnet der Begriff „Datennutzer" jede Partei,
          der der Diensteanbieter Daten und/oder Dienste zur Verfügung stellt oder der der
          Datenanbieter Daten zur Verfügung stellt, und die die Daten nicht weiterverbreitet.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Betreiber</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Ein Anbieter eines oder mehrerer technischer, rechtlicher, verfahrenstechnischer oder
          organisatorischer Dienste, die die Durchführung von Datentransaktionen innerhalb des
          Datenraums ermöglichen. Dazu können z. B. Identitätsmanagement, Zustimmungsmanagement,
          Protokollierung und/oder Dienstmanagement gehören, die in den Anwendungsbereich des von der
          DGA definierten Anbieter von Daten-Vermittlungsdiensten fallen können, aber nicht müssen.
        </p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Im vertraglichen Rahmen des Regelwerks bezeichnet der Begriff „Betreiber" jede Partei, die
          ein Datensystem oder andere Infrastrukturdienste für den Datenraum bereitstellt, die z. B.
          mit dem Identitäts- oder Einwilligungsmanagement, der Protokollierung oder dem
          Dienstmanagement zusammenhängen.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Datenrechtsinhaber</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Eine Entität (eine natürliche oder eine juristische Person), die Rechte und/oder Pflichten
          hat, Zugang zu bestimmten personenbezogenen oder nicht personenbezogenen Daten zu gewähren
          oder diese weiterzugeben. Der Inhaber der Datenrechte kann unter Berücksichtigung anderer
          Datenrechtsinhaber, die Rechte an denselben Daten haben, in seinem eigenen Namen anderen
          Akteuren die Genehmigung zur Nutzung der Daten erteilen. Es kann eine beliebige Anzahl von
          Datenrechtsinhabern an bestimmten Daten geben, und sie können diese Rechte an andere
          übertragen.
        </p>
      </div>
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Ein Akteur, dessen Erlaubnis für die Verarbeitung von Daten erforderlich ist, z. B. eine
          betroffene Person (DSGVO), der Inhaber von IPR-Rechten (z. B. ein Autor), ein Unternehmen,
          das über Geschäftsgeheimnisse verfügt, oder eine Vertragspartei, die vertragliche Rechte an
          Daten hat.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Drittpartei-Datennutzer</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Eine Entität (eine natürliche oder eine juristische Person), die kein Teilnehmer des
          Datenraums ist, den das Regelwerk regelt, die aber Daten erhält oder technisch nutzt
          (ansonsten wie ein „Datennutzer", aber kein Datenraumteilnehmer).
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Berechtigung</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Jedes Recht auf die Verarbeitung von Daten (nicht nur nicht-personenbezogene Daten, wie z.
          B. im Data Governance Act definiert). Eine Erlaubnis kann z. B. eine Einwilligung, eine
          vertragliche Verpflichtung, eine gesetzliche Verpflichtung, ein lebenswichtiges Interesse,
          ein öffentliches Interesse, die Ausübung öffentlicher Befugnisse, ein berechtigtes
          Interesse oder die Verwendung eines damit verbundenen Produkts sein, wenn sie diese
          spezifische Verarbeitung der Daten rechtlich zulässt.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Berechtigungsmanagement</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Sitra Rulebook 3.0 Terminologie</span>
        <p>
          Verwaltung aller Arten von rechtlich relevanten Berechtigungen zur Datennutzung: nicht nur
          aktive Willensbekundungen der Rechteinhaber wie Zustimmungen, Lizenzen und Vereinbarungen,
          sondern beispielsweise auch direkte gesetzliche Rechte zur Verarbeitung von Daten für einen
          bestimmten Zweck oder unter bestimmten Voraussetzungen zur Verarbeitung von Daten für die
          Zwecke berechtigter Interessen. Die Erlaubniserteilung ist ein Prozess, zu dem alle
          relevanten Datenraumteilnehmer und externen Parteien, z. B. Inhaber von Datenrechten,
          Datennutzer, Drittnutzer von Daten, Betreiber und Diensteanbieter, ihren Teil beitragen.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Datenraumträger</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Der Datenraumträger ist die rechtliche Organisation, welche die Governance des Datenraums
          verantwortet.
        </p>
        <p>Zu seinen Aufgaben gehören insbesondere:</p>
        <ul class="gl-list">
          <li>
            Eigentum an geistigem Eigentum (IP), Software, Datenraumarchitektur, Rulebook und
            Markenrechten;
          </li>
          <li>Festlegung und Weiterentwicklung der Teilnahmebedingungen;</li>
          <li>Festlegung und Weiterentwicklung der Governance-Regeln;</li>
          <li>Definition von Rollen, Rechten und Verantwortlichkeiten innerhalb des Datenraums;</li>
          <li>Entscheidung über die Zulassung, Suspendierung oder den Ausschluss von Organisationen;</li>
          <li>strategische Weiterentwicklung des Datenraums.</li>
        </ul>
        <p>
          Der Datenraumträger trägt die Verantwortung für das Datenraumkonzept, die
          Governance-Struktur und das Regelwerk des Datenraums.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Datenraumbetreiber</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Der Datenraumbetreiber ist die Organisation, die den technischen und organisatorischen
          Betrieb des Datenraums sicherstellt.
        </p>
        <p>Zu seinen Aufgaben gehören insbesondere:</p>
        <ul class="gl-list">
          <li>Betrieb der technischen Infrastruktur;</li>
          <li>
            Betrieb zentraler Core Services wie Identity Management, Access Management, Logging und
            Monitoring;
          </li>
          <li>Umsetzung der Governance-Vorgaben des Datenraumträgers;</li>
          <li>Umsetzung und Betrieb der Compliance-Organisation;</li>
          <li>Teilnehmermanagement und operativer Support;</li>
          <li>Betrieb, Wartung und technische Weiterentwicklung der Plattform.</li>
        </ul>
        <p>
          Der Datenraumbetreiber trägt die Verantwortung für den ordnungsgemäßen Betrieb der
          Infrastruktur, die technische Sicherheit sowie die Umsetzung der Governance-Vorgaben des
          Datenraumträgers.
        </p>
      </div>
    </div>
  </section>

  <section class="gl-entry">
    <h2 class="gl-term">Lenkungsausschuss</h2>
    <div class="gl-columns">
      <div class="gl-col">
        <span class="gl-label">Anmerkungen</span>
        <p>
          Der Lenkungsausschuss ist das zentrale Governance- und Entscheidungsorgan des Datenraums.
        </p>
        <p>Zu seinen Aufgaben gehören insbesondere:</p>
        <ul class="gl-list">
          <li>Weiterentwicklung des Rulebooks;</li>
          <li>Entscheidung über Governance-Fragen;</li>
          <li>Genehmigung neuer Mitglieder;</li>
          <li>Genehmigung neuer Datensatztypen;</li>
          <li>Genehmigung neuer Datensatzbeschreibungen;</li>
          <li>Genehmigung neuer Datensatz-Nutzungsbedingungen;</li>
          <li>strategische Weiterentwicklung des Datenraums;</li>
          <li>Überwachung der Umsetzung von Governance-Vorgaben.</li>
        </ul>
        <p>
          Der Lenkungsausschuss arbeitet grundsätzlich konsensorientiert. Soweit erforderlich,
          entscheidet er gemäß den im Governance-Modell festgelegten Abstimmungsregeln.
        </p>
      </div>
    </div>
  </section>

  <p class="gl-stand"><strong>Stand: Version 1.0, Juni 2026</strong></p>
</article>
